import React, { useState } from "react";
import "./styles.css";
import { Input } from "../../../../components/common/Input";
import { UncontrolledInput } from "../../../../components/common/UncontrolledInput";
import { isDune } from "../../../../constants/common";
import {
  ANALYTICS_EVENTS,
  trackAnalyticsEvent,
} from "../../../../analytics";

export const TelegramForm = ({ landing }) => {
  const [form, setForm] = useState({ name: "", phone: "" });
  const [error, setError] = useState({});
  const [isSent, setIsSent] = useState(false);

  const BOT_TOKEN = "7595395249:AAGq5p15egun1gyf5c3Z9sKqIJ-I6OhkuBc";
  const CHAT_IDS = {
    husamHelper: "-4717746434",
    dune: "-1002677462265",
  };

  const handleChange = (field) => (value) => {
    setForm({ ...form, [field]: value });
    setError({ ...error, [field]: null });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let hasError = false;
    if (!form.name) {
      setError((prev) => ({ ...prev, name: "Введите имя" }));
      hasError = true;
    }
    if (!form.phone) {
      setError((prev) => ({ ...prev, phone: "Введите телефон" }));
      hasError = true;
    }
    if (hasError) return;

    const message = `📩 Новая заявка с лендинга <b>${landing}</b>\n\n👤 Имя: ${form.name}\n📱 Телефон: ${form.phone}\n📝 Сообщение: ${e.target.message?.value || "-"}`;

    const res = await fetch(
      `https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          chat_id: isDune ? CHAT_IDS.dune : CHAT_IDS.husamHelper,
          text: message,
          parse_mode: "HTML",
        }),
      },
    );

    if (res.ok) {
      trackAnalyticsEvent(ANALYTICS_EVENTS.LANDING_LEAD_SUBMITTED, {
        landing_id: "ramadan_village",
        lead_channel: "telegram_form",
        form_has_comment: Boolean(e.target.message?.value),
      });
      setIsSent(true);
      setForm({ name: "", phone: "" });
      e.target.reset(); // очистить textarea
    }
  };

  return (
    <div className="ramadan_form">
      <h3>Оставьте заявку</h3>
      {isSent ? (
        <p>✅ Заявка отправлена!</p>
      ) : (
        <form onSubmit={handleSubmit}>
          <Input
            name="name"
            type="text"
            label="Имя"
            placeholder="Ваше имя"
            value={form.name}
            onChange={handleChange("name")}
            error={!!error.name}
            errorMessage={error.name}
          />
          <Input
            name="phone"
            type="text"
            label="Телефон"
            placeholder="Ваш номер"
            value={form.phone}
            onChange={handleChange("phone")}
            error={!!error.phone}
            errorMessage={error.phone}
          />
          <UncontrolledInput
            name="message"
            type="text"
            label="Комментарий (необязательно)"
            placeholder="Ваш вопрос или комментарий"
          />
          <button type="submit" className="telegram_submit-btn">
            Отправить
          </button>
        </form>
      )}
    </div>
  );
};
